<mat-progress-bar [mode]="bufferMode"></mat-progress-bar>
<div>
    <mat-form-field class="select-supervisor">
        <mat-label>Select view</mat-label>
        <select matNativeControl [(ngModel)]="selectedSupervisor" (change)="onSelectSupervisorChange($event)">
            <option *ngFor="let item of listSupervisor; let i = index" [value]="i">{{item.Libele}}</option>
        </select>
    </mat-form-field>
</div>
<div>
    <img class="supervisor-img" 
        *ngIf="isImgLoaded" 
        [src]="imgSupervisor" 
        alt="Supervisor">
</div>
<div *ngIf="isRefreshingSupervisor">Loading....</div>